import Handler from './handler.js'
import { EVENTS } from '@/lib/consts.js'
import { getBaseProperties, getOwnerId } from '@/lib/analytics/helpers.js'
import { DEFAULT_PAYLOAD, USE_IDENTIFY, HANDLER_METHODS } from './consts.js'
import { useCore } from '@/composables/core/index.js'

export default class Segment extends Handler {
  constructor (config, manager) {
    super(config, manager)
    this.handlerSendStack = []
    this.handlerIdentifyStack = []
  }

  __initialize () {
    // GTM handler instance
    const handler = window[this.config.name]

    // shortcut: if handler is ok
    if (handler && typeof handler.track === 'function') {
      // done
      return super.__initialize()
    }

    return true
  }

  send (event) {
    const handlerStack = this.handlerSendStack
    const handler = window[this.config.name]
    // track requires two pamameters so we need to split payload
    const { event: eventName, event_name, settings, [USE_IDENTIFY]: use_identify, ...eventProps } = event

    if (use_identify) {
      this.identify(event)
    }

    this.sendToExternalToolIfAllowed(
      () => handler.track(eventName, eventProps, settings),
      event,
      handlerStack,
      HANDLER_METHODS.TRACK
    )

    handlerStack.push(event)
  }

  identify (event) {
    const handlerStack = this.handlerIdentifyStack
    const handler = window[this.config.name]

    // identify requires two pamameters so we need to split payload
    const {
      settings,
      userId,
      [USE_IDENTIFY]: use_identify,
      event: eventName,
      ...eventProps
    } = event

    // Remove business_admin_status from identify payload
    delete eventProps?.business_admin_status

    this.reset(userId)

    this.sendToExternalToolIfAllowed(
      () => handler.identify(userId, eventProps, settings),
      event,
      handlerStack,
      HANDLER_METHODS.IDENTIFY
    )

    handlerStack.push(event)
  }

  [EVENTS.BUSINESS_SWITCHED] ({ country, routingConfig, business }) {
    const userId = getOwnerId({ business, country, routingConfig })
    const { locale } = useCore().i18n

    this.identify({
      event_name: EVENTS.BUSINESS_SWITCHED,
      userId,
      settings: {
        context: {
          locale,
        },
      },
      locale,
    })

    return this.sendingSkipped
  }

  reset (userId) {
    const handler = window[this.config.name]
    const savedUserId = this.getSavedUserId()

    // Reset only if user id exists and is not the same.
    // It's important to keep the same asynchronous id for not logged user.
    if (savedUserId && savedUserId !== userId) {
      handler.reset()
    }
  }

  getSavedUserId () {
    const handler = window[this.config.name]

    try {
      return handler.user().id()
    } catch (e) {
      return null
    }
  }

  getFacebookSettings () {
    return {
      integrations: {
        'All': false,
        'Facebook Pixel': true,
        'Facebook Conversions API (Actions)': true,
      },
    }
  }

  [DEFAULT_PAYLOAD] (data) {
    const baseProperties = getBaseProperties(data)
    const { locale } = useCore().i18n
    const {
      app_version,
      business_id,
      business_phone,
      country,
      device_type,
      email,
      logged_in_user_id,
      offer_type,
      user_role,
      user_id,
    } = baseProperties

    return {
      app_version,
      business_id,
      business_phone,
      country,
      device_type,
      email,
      logged_in_user_id,
      offer_type,
      user_role,
      userId: user_id,
      settings: {
        context: {
          locale,
        },
      },
      locale,
    }
  }
}
